import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import {Decimal} from "decimal.js";
import moment from "moment";
import ReactLoading from "react-loading";
import axios from "axios";
import {uuidGenerator} from "./erpHelper";

class GetEdefterFromConnectorModalWs extends Component {

    constructor(props) {
        super(props);
        this.state ={
            selectedList:[],
            journalList:[],
            randomColorList:[],
            searchQuery:undefined,
            index:0,
            totalLength:null,
            kalanLength:null,
            loopSize:null,
            loopIndex:0,
            savedIndex:0,
            connected:false,
            saveClicked:false,
            buttonText:"Erp'den Getir",
            buttonState:0
        };
        this.documentInformation = this.documentInformation.bind(this);
        this.restartSend = this.restartSend.bind(this);
        this.confirm = this.confirm.bind(this);
    }

    componentDidMount() {
        let {connectionInfo} = this.props;
        this.listenWebSocket(connectionInfo.ownerIp);
        this.intervalId = setInterval(this.restartSend, 6 * 60 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    async restartSend()  {
        let self = this;
        await self.documentInformation();
        await self.confirm();
    }

    getStatusRender = (status) => {
        let className;
        let color;
        switch(status) {
            case "processing":
                className = "spinner fa-spin";
                color = "dark"
                break;
            case "success":
                className = "check";
                color = "green";
                break;
            case "error":
                className = "close";
                color = "red";
                break;
            default:
                className = "pause";
                color = "dark";
        }
        return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
    }

    onChange = (e,index) => {
        let journalList = deepCopyObject(this.state.journalList);
        journalList[index][e.name]=
            ((e.name === "invoiceQuantity" && e.value !== "" ) ||
                (e.name === "unitPrice"  && e.value !== "") ||
                (e.name === "allowancePercent"  && e.value !== "") ||
                (e.name === "allowanceAmount"  && e.value !== "") ||
                (e.name === "kdvPercent"  && e.value !== "") ||
                (e.name === "kdvAmount"  && e.value !== "") ||
                (e.name === "lineExtensionAmount"  && e.value !== "")) ? (new Decimal(e.value)).toNumber() : e.value;
        this.setState({journalList});
    }

    journalFinal = () => {
        let {journalList} = this.state;
        let customerId = this.props.connectionInfo.customerId;
        let defterconnectorList = journalList.map(journal=>{
            let period = parseInt(journal.PERIOD_COVERED_END.split('-')[0]+journal.PERIOD_COVERED_END.split('-')[1]);
            return {
                customer:customerId,
                enteredBy:journal.ENTERED_BY,
                period:period,
                enteredDate:journal.ENTERED_DATE,
                entryComment:journal.ENTRY_COMMENT,
                totalDebit:journal.TOTAL_DEBIT,
                totalCredit:journal.TOTAL_CREDIT,
                entryNumberCounter:journal.ENTRY_NUMBER_COUNTER,
                paymentMethod:journal.PAYMENT_METHOD,
                documentType:journal.DOCUMENT_TYPE,
                documentTypeDesc:journal.DOCUMENT_TYPE_DESCRIPTION,
                documentNumber:journal.DOCUMENT_NUMBER,
                documentReference:journal.DOCUMENT_REFERENCE,
                documentDate:journal.DOCUMENT_DATE,
                lineNumber:journal.LINE_NUMBER,
                accMainId:journal.ACCOUNT_MAIN_ID,
                accMainDesc:journal.ACCOUNT_MAIN_DESCRIPTION,
                accSubId:journal.ACCOUNT_SUB_ID,
                accSubDesc:journal.ACOUNT_SUB_DESCRIPTION,
                amount:journal.AMOUNT,
                debitCreditcode:journal.DEBIT_CREDIT_CODE,
                detailComment:journal.DETAIL_COMMENT
            }
        })
        defterconnectorList = deepCopyObject(defterconnectorList);
        return (defterconnectorList);
    }

    confirm = async () => {
        let self= this;
        this._source = axios.CancelToken.source();
        let journalList = self.journalFinal();

        self.setState({saveClicked:true});
        await self.addDefter(deepCopyObject(journalList))
        //self.checkSaved();

    }

    buttonJob = async () => {
        let self = this;
        switch (self.state.buttonState){
            case 0:
                await self.documentInformation();
                break;
            case 1:
                await self.confirm();
                break;
        }
    }

    addDefter = async (journal) =>{
        let self = this;
        let params = {
            url: `/connector/saveJournalFromWS`,
            method: "post",
            data: journal
        };
        try {
            let {data} = await request(params);
            if (data==="ok"){
                await self.documentInformation();
            }
        }catch(error){
            let err = {response:{data:"Kayıt Hatası"}}
            showAxiosError(err);
        }
    }


    documentInformation = async ()=> {
        let self = this;
        self.setState({searching:true});
        let probableDefter = self.props.probableDefter;
        let params = {
            url: `/connector/getDefter/${probableDefter}`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            let limit = data.limit ? data.limit:50;
            self.setState({limit, savedIndex:0});
            this.send(data.query,"DEFTER_LENGTH");
        }catch(error){
            let err = {response:{data:"Bağlantı Hatası"}}
            showAxiosError(error);
            self.setState({journalList:[],searching:false});
        }
    }

    handleSearch = async ()=> {
        let self = this;

        let {limit,loopSize,loopIndex} = self.state;
        let probableDefter = self.props.probableDefter;
        if(loopSize>=loopIndex){
            let params = {
                url: `/connector/readDefter/${probableDefter}/${limit}`,
                method: "post"
            };
            self.setState({searching: true,confirmBtnDisabled:false});
            try{
                let {data} = await request(params);
                loopIndex+=1;
                self.setState({loopIndex});
                self.send(data,"READ_DEFTER");

            }catch(error){
                let err = {response:{data:"Bağlantı Hatası"}}
                showAxiosError(err);
                self.setState({journalList:[],searching:false});
            }
        }else {
            Alert.success("Defter kaydedildi.", {
                position: 'bottom-right',
                effect: 'stackslide',
                timeout: 4000
            });
        }

    }

    onCancel = () => {
        if(this._source)
            this._source.cancel();

        if(this.state.index > 0){
            this.props.toggleModal(false,true);
        }else{
            this.props.toggleModal(false,false);
        }
        this.state.ws.close();
    }

    listenWebSocket = async (ip) =>{
        let self = this;
        ip= ip + "/websocket/chat";
        const ws = new WebSocket(ip);
        this.setState({ws});

        let ready = ws.readyState;

        ws.onopen = () => {
            this.setState({connected:true});
        }

        // listen to data sent from the websocket server
        ws.onmessage = async evt => {
            let {queryType,rows,uuid} = JSON.parse(evt.data)
            rows = JSON.parse(rows);
            if(queryType === "ERROR" && rows && rows.error){
                console.log(rows.error);
                this.setState({searching:false})
            } else if((queryType === "DEFTER_LENGTH") && rows != null){
                const {limit} = this.state;
                let totalLength = rows[0].ALL_COUNT;
                let kalanLength = rows[0].REMAINING;
                let loopSize= Math.ceil(totalLength/limit);
                if (self.state.loopSize!==null)
                    loopSize=self.state.loopSize;
                if (kalanLength===0){
                    this.onCancel();
                    Alert.success("Defter aktarımı tamamlandı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                }
                self.props.setTotalCount(totalLength);
                let buttonText = "Kaydet";
                let buttonState = 1;
                self.setState({totalLength, kalanLength, loopSize,buttonText,buttonState});
                self.handleSearch();
            }else if((queryType === "READ_DEFTER") && rows != null ) {

                if (rows.length === 0) {
                    this.onCancel();
                    Alert.success("Ara kriterlerine uygun defter bulunamadı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 4000
                    });
                }
                self.setState({journalList:rows,searching:false,index:0});

                if(rows.length>0 && this.state.saveClicked){
                    await this.confirm();
                }
            }
        }

        ws.onclose = () => {
            this.setState({connected:false});
            self.listenWebSocket(self.props.connectionInfo.ownerIp)
        }
    }


    uuidGenerator = ()=> {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    send = (query,queryType,documentUuid) =>{
        const {connectionInfo,currentUser} = this.props;

        let header = {
            customerId: currentUser.customerId,
            dataSource: connectionInfo.dataSource,
            initialCatalog: connectionInfo.initialCatalog,
            dbUser: connectionInfo.dbUser,
            dbPassword: connectionInfo.dbPassword,
            key: connectionInfo.key,
            branchId: connectionInfo.branchId,
            clientType:"PORTAL"
        }
        let body = {
            uuid:documentUuid?documentUuid: uuidGenerator(),
            queryType: queryType,
            query: query
        };

        let ws = this.state.ws;
        let jsonMsg = JSON.stringify({header,body})
        ws.send(jsonMsg);
    }

    render() {

        let {journalList: journalList} = this.state;

        // const fields = [
        //     {
        //         label: "Yıl",
        //         accessor: "year",
        //         type: "text",
        //         operator: "=",
        //     },
        //     {
        //         label: "Ay",
        //         accessor: "month",
        //         type: "text",
        //         operator: "=",
        //     },
        // ];

        return (
            <DefaultModal disabled={this.state.searching || this.state.confirmBtnDisabled}
                          isOpen={this.props.modal}
                          size="xxl"
                          title={this.props.title || ""}
                          // applyBtnText="Erp'den Getir"
                          confirmBtnText={this.state.buttonText}
                          cancelBtnText="Kapat"
                          onConfirm={()=>this.buttonJob()}
                          onCancel={this.onCancel}
                          // onApply={this.documentInformation}
            >
                <div className="row satirBasi" style={{marginTop: 20}}>
                    {/*<div className="col-sm-12" style={{zIndex:9999,padding: '1',maxHeight:'450px'}}>*/}
                    {/*    <DetailedSearch fields={fields}*/}
                    {/*                    loading={this.state.searching}*/}
                    {/*                    onSearch={this.documentInformation}/>*/}
                    {/*</div>*/}
                    <div className="col-sm-12" style={{paddingBottom: '20px',maxHeight:'500px', overflow:"auto"}}>
                        {this.state.searching &&
                            <ReactLoading type="spinningBubbles" style={{
                                width: "70px",
                                height: "70px",
                                margin: "20px auto 0 auto",
                                fill: "#888"
                            }}/>
                        }
                        {!this.state.searching && journalList.length>0 &&
                            <table className="" style={{textAlign: 'center'}}>
                                <thead>
                                <tr style={{backgroundColor: '#ebedf0'}}>
                                    <th width="8%">Ana Hesap</th>
                                    <th width="8%">Alt Hesap</th>
                                    <th width="8%">Tutar</th>
                                    <th width="8%">Fiş Numarası</th>
                                    <th width="8%">Giriş Tarihi</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.journalList.map((journal, index) =>
                                    <tr key={index}>
                                        <td>
                                            <div style={{display:'inline'}}>
                                                {journal.ACCOUNT_MAIN_ID}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{display:'inline'}}>
                                                {journal.ACCOUNT_SUB_ID}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{display:'inline'}}>
                                                {journal.AMOUNT}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{display:'inline'}}>
                                                {journal.DOCUMENT_REFERENCE}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{display:'inline'}}>
                                                {moment(journal.ENTERED_DATE).isValid() ? moment(journal.ENTERED_DATE).format("DD-MM-YYYY") : ''}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        }
                    </div>
                    <div className="col-sm-12" style={{display:"flex", justifyContent:"flex-end"}}>

                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Durum: {this.getStatusRender(this.state.connected? "success":"processing")}</div>
                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Gösterilen Madde Sayısı: {this.state.journalList ? this.state.journalList.length : 0}</div>
                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Toplam Madde Sayısı: {this.state.totalLength ? this.state.totalLength : 0}</div>
                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Kalan Madde Sayısı: {this.state.kalanLength ? this.state.kalanLength : 0}</div>
                    </div>
                </div>
            </DefaultModal>
        )
    }
}

export default GetEdefterFromConnectorModalWs;